import React, { useEffect, useMemo, useState } from "react";
import { useShowModal } from "../../../hooks";
import { AddBtn, LoyihaMap, WrapperLoyiha } from "./style";
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import Tab from "../../../components/Tab";
import Button from "../../../components/FormElement/Button";
import service from "../../../services/projects";
import categoryService from "../../../services/projectCategory";
import CustomPagination from "../../../components/FormElement/Pagination";
import ProjectCard from "../../../components/Cards/ProjectCard";
import DeleteModal from "../../../components/DeleteModal";
import { useShowAlert } from "../../../hooks/useAlerts";
import { useHideModal } from "../../../hooks";
import Spinner from "../../../components/Spinner/FullScreen";

function Project() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const { hideModal } = useHideModal();
  const { showBlured } = useShowModal();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);

  const options = useMemo(
    () => [
      { key: "", label: "Barchasi" },
      ...categories.map((category) => ({
        key: category.id.toString(),
        label: category.title,
      })),
    ],
    [categories]
  );

  const categoryQuery = useMemo(
    () => (selectedCategory ? `&proCategory=${selectedCategory}` : ""),
    [selectedCategory]
  );

  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : ""),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );

  const query = useMemo(
    () => `${pageQuery}${limitQuery}${categoryQuery}`,
    [pageQuery, limitQuery, categoryQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result.rows.map((item, idx) => ({
        ...item,
        img: item.media,
        index: pagination.page * pagination.limit - pagination.limit + idx + 1,
      }));
      setData(finalResult);
      setTotal(result.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [query]);

  useEffect(() => {
    setLoading(true);
    categoryService
      .getAll()
      .then((resp) => {
        setCategories(resp);
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleDelete = (id) => {
    showBlured({
      title: "",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <DeleteModal onClick={() => onDelete(id)} />,
    });
  };

  const onDelete = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleUpdate = (id) => {
    navigate("/projects/form", { state: id });
  };

  const handleAddClick = () => {
    navigate("/projects/form");
  };

  const changeTab = (key) => {
    setPagination((prev) => ({ ...prev, page: 1 }));
    setSelectedCategory(key);
  };

  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };

  if (loading) return <Spinner />;
  return (
    <WrapperLoyiha>
      <AddBtn>
        <Tab
          tabs={options}
          defaultCurrent={selectedCategory}
          onChange={(key) => changeTab(key)}
        />
        <Button
          icon={<PlusOutlined />}
          text="Qo'shish"
          onClick={handleAddClick}
          width="120px"
        />
      </AddBtn>

      <LoyihaMap>
        {data?.map((item) => (
          <div key={item.id}>
            <ProjectCard
              key={item.id}
              data={item}
              handleUpdate={() => handleUpdate(item.id)}
              handleDelete={() => handleDelete(item.id)}
            />
          </div>
        ))}
        {total > 10 && (
          <CustomPagination
            align="end"
            total={total}
            onChange={handleChangePagination}
            defaultPageSize={pagination.limit}
            defaultCurrent={pagination.page}
          />
        )}
      </LoyihaMap>
    </WrapperLoyiha>
  );
}

export default Project;
